// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.button-icon[data-v-01a94d52] {\n    width: 35px !important;\n    min-width: 35px !important;\n    padding-left: 8px !important;\n}\n.signature[data-v-01a94d52] {\n    height: 100px;\n    overflow: auto;\n    font-size: 0.75em;\n    line-break: anywhere;\n}\n.sign-text[data-v-01a94d52] {\n    white-space: pre-line;\n}\npre[data-v-01a94d52] {\n    font-size: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
